import React from 'react';
import { connect } from 'react-redux';
import { Translate } from "react-localize-redux";
// import PhotoSearchCard from "../../PhotoSearchCard";
import ContactCard from '../../ContactCard';
import { Modal } from 'reactstrap';
import './styles.scss';

class MyCardModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const { contacts, profile, loggedIn, loggedInUser } = this.props;

    return (
      <React.Fragment>
        <a className="dropdown-menu-link" onClick={this.toggle}>
          <Translate id="myCardText" />
        </a>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          id="my-contact-card-modal"
          className={`${this.props.className} no-min-height contact-card-modal`}
          size="lg"
        >
          <ContactCard
            key={profile.id}
            hasContacts={contacts.length > 0}
            profile={profile}
            loggedInUser={loggedInUser}
            contacts={loggedInUser.contacts}
            isUserLoggedIn={loggedIn}
            showShare={true}
            showAdd={false}
            showContactAction
            allowedToViewContacts
          />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loggedInUser: state.profile.profile,
  contacts: state.profile.profile.contacts,
  profile: state.profile.profile,
  loggedIn: state.auth.loggedIn,
});

export default connect(mapStateToProps)(MyCardModal);



// WEBPACK FOOTER //
// ./src/components/modals/MyCardModal/MyCardModal.jsx